import React from 'react'
import ReactDOM from 'react-dom'

import reportWebVitals from './reportWebVitals'
import { BrowserRouter, Switch, Route} from 'react-router-dom'


//STYLES IMPORTS
import "antd/dist/antd.css"

//COMPONENTS IMPORTS
import TopNavbar from './components/TopNavbar'
import Menu from './components/Menu'
import ScrollToTop from './components/ScrollToTop'

//PAGES IMPORTS
import Introduction from './pages/Introduction'
import BestPratices from './pages/BestPratices'
import TurnOn from './pages/TurnOn'
import BlankScreen from './pages/BlankScreen'
import HowToUse from './pages/HowToUse'

ReactDOM.render(
  
  
  <React.StrictMode>
    <BrowserRouter>
      <TopNavbar/>
      <Menu className='menu-desktop'/>
      <ScrollToTop>
        <Switch>
          <Route exact path="/" component = {Introduction}/>
          <Route exact path="/melhores-praticas" component = {BestPratices}/>
          <Route exact path="/como-ligar" component = {TurnOn}/>
          <Route exact path="/tela-branca" component = {BlankScreen}/>
          <Route exact path="/como-utilizar" component = {HowToUse}/>
        </Switch>
      </ScrollToTop>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
  
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
